"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./modules/localize");
require("./modules/contact-form");
